module.exports = "<span *ngFor=\"let p of popovers\" class=\"task-filter\" [popover]=\"popTask\" placement=\"top\" triggers=\"mouseenter:mouseleave\">\n  <span class=\"task-filter-left\">{{p.name}}</span><span class=\"task-filter-right\">{{p.count}}</span>\n  <ng-template #popTask>\n    <div class=\"filter-pop-header\">{{p.description}}</div>\n    <div class=\"filter-pop-body\" [innerHtml]=\"p.body\"></div>\n  </ng-template>\n</span>\n<span *ngIf=\"popovers.length == 0\">\n  n/a\n</span>"


//////////////////
// WEBPACK FOOTER
// ./client/app/automate/filter-popover/filter-popover.component.html
// module id = ./client/app/automate/filter-popover/filter-popover.component.html
// module chunks = main